import { useNavigate } from "react-router";
import { MITTEILUNGEN_PFAD } from "../mitteilungen";
import { anzeigename, rollenEtiketten } from "../namen";
import { useAngemeldet, useSitzung } from "../sitzung";
import { Avatar } from "../ui/Avatar";
import { Marke } from "../ui/Marke";
import { Menue } from "../ui/Menue";
import { Icon } from "./Icon";
import s from "./shell.module.css";

/** Personenmenü am Bild in der Kopfzeile, auch am Handy (KOPFZEILE.md, Abschnitt 3.5): Kopf mit Bild, Name und Rollen,
 *  dann Profil, Benachrichtigungen und Abmelden auf diesem Gerät. „Überall abmelden“ bleibt im Profil. */
export function PersonenMenue() {
  const { person, gruppen } = useAngemeldet();
  const { abmelden } = useSitzung();
  const navigate = useNavigate();
  const name = anzeigename(person);
  const rollen = rollenEtiketten(gruppen);
  return (
    <Menue
      label={`${name}, Menü`}
      menueLabel={`${name}, ${rollen.map((r) => r.label).join(", ")}`}
      klasse={s.bild}
      knopf={<Avatar person={person} groesse={34} />}
      breite={290}
      kopf={
        <div className={s.menueKopf}>
          <Avatar person={person} groesse={48} />
          <div>
            <b>{name}</b>
            <span className={s.etiketten}>
              {rollen.map((r) => (
                <Marke key={r.label} art={r.dunkel ? "dunkel" : "normal"}>
                  {r.label}
                </Marke>
              ))}
            </span>
          </div>
        </div>
      }
      punkte={[
        { label: "Profil und Foto", symbol: <Icon name="person" />, ausfuehren: () => navigate("/profil") },
        { label: "Benachrichtigungen", hinweis: "Push, Mail", symbol: <Icon name="glocke" />, ausfuehren: () => navigate(`${MITTEILUNGEN_PFAD}#einstellungen`) },
        { label: "Abmelden", trenner: true, symbol: <Icon name="abmelden" />, ausfuehren: () => void abmelden(false) },
      ]}
    />
  );
}
